<script lang="ts">
    export let disabled: boolean = false;
    export let onClick: (event: Event) => void = undefined
    export let type: "primary" | "secondary" | "accept" | "decline" = "primary"
</script>

<button class={`button ${type}`} on:click={onClick} disabled={disabled}>
    <slot/>
</button>

<style>
    .button {
        border-radius: 6px;
        border-width: 0;
        box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .1) 0 2px 5px 0, rgba(0, 0, 0, .07) 0 1px 1px 0;
        color: #fff;
        cursor: pointer;
        height: 44px;
        line-height: 1.15;
        margin: 12px 5px 0 0;
        outline: none;
        padding: 0 25px;
        transition: all .2s ease-in-out;
        user-select: none;
        -webkit-user-select: none;
        font-size: 20px;
        font-weight: bolder;
    }

    .button.primary {
        background-color: #405cf5;
    }

    .button.primary:hover {
        background-color: #2d49d9;
    }

    .button.secondary {
        background-color: #a9a9b0;
    }

    .button.secondary:hover {
        background-color: #86868c;
    }

    .button.accept {
        background-color: #089608;
    }

    .button.accept:hover {
        background-color: #047904;
    }

    .button.decline {
        background-color: #a50808;
    }

    .button.decline:hover {
        background-color: darkred;
    }
</style>

